import React, { FC, memo, useCallback, useEffect } from "react";

import { languageOptions } from "@features/languages/constants";
import { useAppDispatch, useAppSelector } from "@features/store/hooks";
import { setUserLanguageData } from "@features/user/store/thunks/setUserLanguageData";
import { cookieLanguageStorageService } from "@features/user/utils/cookieUserPreferencesStorageService";
import { Select } from "@packages/uiKit";
import { StyledLanguageSelector } from "./styles";

interface LanguageSelectorProps {
  className?: string;
  style?: React.CSSProperties;
}

const _LanguageSelector: FC<LanguageSelectorProps> = (props) => {
  const { ...restProps } = props;

  const dispatch = useAppDispatch();
  const selectedLanguage = useAppSelector((state) => state.language.value);

  useEffect(() => {
    const language = cookieLanguageStorageService.getLanguage();

    if (language) {
      dispatch(
        setUserLanguageData({
          language: language,
        })
      );
    }
  }, [dispatch]);

  const languageChangeHandler = useCallback(
    (language: string) => {
      dispatch(
        setUserLanguageData({
          language: language,
        })
      );
      window.location.reload();
    },
    [dispatch]
  );

  return (
    <StyledLanguageSelector {...restProps}>
      <Select
        options={languageOptions}
        disableCaret
        placeholder={selectedLanguage}
        value={selectedLanguage}
        onChange={languageChangeHandler}
        size="noCaret"
      />
    </StyledLanguageSelector>
  );
};

export const LanguageSelector = memo(_LanguageSelector);
